<section class="assistant-store-view" *ngIf="vm.assistantStoreView() === 'instances'">
  <div class="store-instance-panel">
    <header class="store-instance-panel-header">
      <div>
        <h3>{{ 'assistant.management.store.instances.title' | i18n }}</h3>
        <p>{{ 'assistant.management.store.instances.subtitle' | i18n }}</p>
      </div>
      <div class="store-instance-header-actions">
        <div class="store-instance-total">
          <i nz-icon nzType="shop" nzTheme="outline"></i>
          {{ 'assistant.management.store.market.count-prefix' | i18n }} {{ vm.storeInstanceStats().total }}
          {{ 'assistant.management.store.instances.count-suffix' | i18n }}
        </div>
        <button
          nz-button
          type="button"
          class="store-refresh-button"
          [nzLoading]="vm.storeLoading()"
          [disabled]="vm.storeLoading()"
          (click)="vm.refreshAssistantStoreInstances()"
          testId="assistant-instances-refresh-button"
        >
          <i nz-icon nzType="reload" nzTheme="outline"></i>
          {{ 'common.refresh' | i18n }}
        </button>
      </div>
    </header>

    <div class="store-instance-stats">
      <button
        type="button"
        class="store-instance-stat"
        (click)="vm.updateStoreInstanceStatusFilter('Trialing')"
        testId="assistant-instances-stat-trialing"
      >
        <span>{{ 'assistant.management.store.stat.trialing' | i18n }}</span>
        <strong>{{ vm.storeInstanceStats().trialing }}</strong>
      </button>
      <button
        type="button"
        class="store-instance-stat"
        (click)="vm.updateStoreInstanceStatusFilter('Active')"
        testId="assistant-instances-stat-active"
      >
        <span>{{ 'assistant.management.store.stat.active' | i18n }}</span>
        <strong>{{ vm.storeInstanceStats().active }}</strong>
      </button>
      <button
        type="button"
        class="store-instance-stat store-instance-stat-warning"
        (click)="vm.updateStoreInstanceStatusFilter('Expiring')"
        testId="assistant-instances-stat-expiring"
      >
        <span>{{ 'assistant.management.store.stat.expiring' | i18n }}</span>
        <strong>{{ vm.storeInstanceStats().expiring }}</strong>
      </button>
      <button
        type="button"
        class="store-instance-stat store-instance-stat-danger"
        (click)="vm.updateStoreInstanceStatusFilter('Expired')"
        testId="assistant-instances-stat-expired"
      >
        <span>{{ 'assistant.management.store.stat.recoverable' | i18n }}</span>
        <strong>{{ vm.storeInstanceStats().recoverable }}</strong>
      </button>
    </div>

    <div class="store-instance-controls">
      <div class="store-instance-filter-group">
        <button
          type="button"
          *ngFor="let option of vm.storeInstanceStatusOptions"
          [class.is-active]="vm.storeInstanceStatusFilter() === option.value"
          (click)="vm.updateStoreInstanceStatusFilter(option.value)"
          [testId]="'assistant-instances-filter-' + option.value"
        >
          {{ option.labelKey | i18n }}
        </button>
      </div>
      <nz-input-group nzPrefixIcon="search" class="store-instance-search">
        <input
          nz-input
          [ngModel]="vm.storeInstanceKeyword()"
          (ngModelChange)="vm.updateStoreInstanceKeyword($event)"
          [placeholder]="'assistant.management.store.instances.search.placeholder' | i18n"
          testId="assistant-instances-search-input"
        />
      </nz-input-group>
    </div>
  </div>

  <nz-spin [nzSpinning]="vm.storeLoading()">
    <div class="store-instance-table-wrap" *ngIf="vm.filteredStoreSubscriptions().length > 0; else emptyInstances">
      <table class="store-instance-table" testId="assistant-instances-table">
        <thead>
          <tr>
            <th>{{ 'assistant.management.store.instances.column.name' | i18n }}</th>
            <th>{{ 'assistant.management.store.instances.column.template' | i18n }}</th>
            <th>{{ 'assistant.management.store.instances.column.status' | i18n }}</th>
            <th>{{ 'assistant.management.store.instances.column.validity' | i18n }}</th>
            <th>{{ 'assistant.management.store.instances.column.create-method' | i18n }}</th>
            <th>{{ 'assistant.management.store.instances.column.actions' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let subscription of vm.filteredStoreSubscriptions()"
            [attr.data-testid]="'assistant-instances-row-' + subscription.assistantId"
          >
            <td>
              <strong>{{ vm.getStoreInstanceName(subscription) }}</strong>
              <span>{{ vm.getStoreInstanceSubtitle(subscription) }}</span>
            </td>
            <td>
              <strong
                >{{ 'assistant.management.store.instances.template-prefix' | i18n }}
                {{ vm.getStoreInstanceTemplateName(subscription) }}</strong
              >
              <span>{{ subscription.providerName || ('assistant.store.provider.official' | i18n) }}</span>
            </td>
            <td>
              <nz-tag class="store-status-tag" [nzColor]="vm.getStoreStatusColor(subscription.status)">{{
                vm.isExpiringStoreSubscription(subscription)
                  ? ('assistant.management.store.status.expiring' | i18n)
                  : (vm.getStoreStatusLabel(subscription.status) | i18n)
              }}</nz-tag>
              <small *ngIf="vm.getStoreInstanceStatusHint(subscription) as hint">{{ hint }}</small>
              <small class="store-payment-countdown" *ngIf="vm.getStorePendingPaymentCountdown(subscription) as countdown">
                <i nz-icon nzType="hourglass" nzTheme="outline"></i>
                <span>{{ 'payment.result.countdown.label' | i18n }}</span>
                <strong>{{ countdown }}</strong>
              </small>
            </td>
            <td>{{ vm.getStoreValidityRange(subscription) }}</td>
            <td>{{ vm.getStoreCreateMethodLabel(subscription.createMethod) }}</td>
            <td>
              <div class="store-instance-actions">
                <button
                  nz-button
                  type="button"
                  (click)="vm.openStoreInstanceDetail(subscription)"
                  [testId]="'assistant-instances-detail-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="eye" nzTheme="outline"></i>
                  {{ 'assistant.management.store.action.detail' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="primary"
                  type="button"
                  *ngIf="vm.isStoreSubscriptionPendingPayment(subscription) && !vm.isStorePendingPaymentExpired(subscription)"
                  (click)="vm.continueStorePendingPayment(subscription)"
                  [testId]="'assistant-instances-pay-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="credit-card" nzTheme="outline"></i>
                  {{ 'assistant.management.store.action.pay-now' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="primary"
                  type="button"
                  class="store-instance-renew-button"
                  *ngIf="vm.isStorePendingPaymentExpired(subscription)"
                  (click)="vm.rePayStoreSubscription(subscription)"
                  [testId]="'assistant-instances-repay-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="reload" nzTheme="outline"></i>
                  {{ 'assistant.management.store.action.renew' | i18n }}
                </button>
                <button
                  nz-button
                  type="button"
                  class="store-instance-renew-button"
                  *ngIf="!vm.isStoreSubscriptionPendingPayment(subscription) && vm.canRenewStoreSubscription(subscription)"
                  [nzLoading]="vm.storeActionLoadingId() === 'renew-' + subscription.subscriptionId"
                  (click)="vm.openStoreRenewPackageModal(subscription)"
                  [testId]="'assistant-instances-renew-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="reload" nzTheme="outline"></i>
                  {{
                    vm.canRecoverStoreSubscription(subscription)
                      ? ('assistant.management.store.action.renew-recover' | i18n)
                      : ('assistant.management.store.action.renew' | i18n)
                  }}
                </button>
                <button
                  nz-button
                  nzType="primary"
                  type="button"
                  *ngIf="vm.canEnableStoreSubscription(subscription)"
                  [nzLoading]="vm.storeActionLoadingId() === 'enable-' + subscription.assistantId"
                  (click)="vm.enableAssistantStoreSubscription(subscription)"
                  [testId]="'assistant-instances-enable-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="poweroff" nzTheme="outline"></i>
                  {{ 'assistant.management.action.enable' | i18n }}
                </button>
                <button
                  nz-button
                  nzDanger
                  type="button"
                  *ngIf="vm.canStopStoreSubscription(subscription)"
                  [nzLoading]="vm.storeActionLoadingId() === 'stop-' + subscription.assistantId"
                  (click)="vm.stopAssistantStoreSubscription(subscription)"
                  [testId]="'assistant-instances-stop-button-' + subscription.assistantId"
                >
                  <i nz-icon nzType="poweroff" nzTheme="outline"></i>
                  {{ 'assistant.management.store.action.stop' | i18n }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #emptyInstances
      ><nz-empty [nzNotFoundContent]="'assistant.management.store.empty.instances' | i18n"
        ><button nz-button nzType="primary" (click)="vm.selectAssistantStoreView('market')" testId="assistant-instances-go-market-button">{{
          'assistant.management.store.action.go-market' | i18n
        }}</button></nz-empty
      ></ng-template
    >
  </nz-spin>
</section>

<nz-modal
  [nzVisible]="vm.storeInstanceDetailVisible()"
  [nzWidth]="760"
  [nzMaskClosable]="false"
  [nzClosable]="false"
  [nzFooter]="null"
  nzClassName="assistant-instance-detail-modal"
  (nzOnCancel)="vm.closeStoreInstanceDetail()"
  testId="assistant-store-instance-detail-modal"
>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="vm.storeInstanceDetailLoading()">
      <div class="instance-detail-shell" *ngIf="vm.selectedStoreInstance() as instance">
        <header class="instance-detail-header">
          <div>
            <span>{{ 'assistant.management.store.instance-detail.eyebrow' | i18n }}</span>
            <h2>{{ 'assistant.management.store.instance-detail.title' | i18n }}</h2>
            <p>{{ 'assistant.management.store.instance-detail.subtitle' | i18n }}</p>
          </div>
          <button
            type="button"
            class="instance-detail-close"
            (click)="vm.closeStoreInstanceDetail()"
            [attr.aria-label]="'common.close' | i18n"
            testId="assistant-store-instance-detail-close-button"
          >
            <i nz-icon nzType="close"></i>
          </button>
        </header>

        <main class="instance-detail-content">
          <section class="instance-detail-section instance-editable-section">
            <div class="instance-section-heading">
              <i nz-icon nzType="edit" nzTheme="outline"></i>
              <div>
                <h3>{{ 'assistant.management.store.instance-detail.identity' | i18n }}</h3>
                <p>{{ 'assistant.management.store.instance-detail.identity-hint' | i18n }}</p>
              </div>
            </div>
            <div class="instance-identity-editor">
              <div class="instance-avatar-editor">
                <div class="instance-avatar-preview">
                  <img
                    *ngIf="vm.storeInstanceAvatarPreview; else instanceAvatarFallback"
                    [src]="vm.storeInstanceAvatarPreview"
                    [alt]="vm.storeInstanceName"
                  />
                  <ng-template #instanceAvatarFallback><i nz-icon nzType="robot"></i></ng-template>
                </div>
                <label class="instance-avatar-upload" for="store-instance-avatar-input">
                  <i nz-icon nzType="upload"></i>
                  {{ 'assistant.management.create.basic.avatar.replace' | i18n }}
                </label>
                <input
                  id="store-instance-avatar-input"
                  type="file"
                  accept="image/*"
                  (change)="vm.onStoreInstanceAvatarFileChange($event)"
                  testId="assistant-store-instance-avatar-input"
                />
              </div>
              <div class="instance-name-field">
                <label for="store-instance-name-input">{{ 'assistant.management.create.basic.name' | i18n }}</label>
                <input
                  id="store-instance-name-input"
                  nz-input
                  maxlength="50"
                  [(ngModel)]="vm.storeInstanceName"
                  testId="assistant-store-instance-name-input"
                />
                <small>{{ vm.storeInstanceName.length }} / 50</small>
              </div>
            </div>
          </section>

          <section class="instance-detail-section">
            <div class="instance-section-heading">
              <i nz-icon nzType="file-text" nzTheme="outline"></i>
              <h3>{{ 'assistant.management.store.instance-detail.template-info' | i18n }}</h3>
            </div>
            <dl class="instance-detail-grid">
              <div
                ><dt>{{ 'assistant.management.store.instance-detail.source-template' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceTemplateName(instance) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.instance-detail.provider' | i18n }}</dt
                ><dd>{{ instance.providerName || ('assistant.store.provider.official' | i18n) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.instances.column.create-method' | i18n }}</dt
                ><dd>{{ vm.getStoreCreateMethodLabel(instance.createMethod) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.instances.column.status' | i18n }}</dt
                ><dd>{{ vm.getStoreStatusLabel(instance.status) | i18n }}</dd></div
              >
            </dl>
          </section>

          <section class="instance-detail-section">
            <div class="instance-section-heading">
              <i nz-icon nzType="calendar" nzTheme="outline"></i>
              <h3>{{ 'assistant.management.store.instances.column.validity' | i18n }}</h3>
            </div>
            <p class="instance-validity">{{ vm.getStoreValidityRange(instance) }}</p>
          </section>

          <section class="instance-detail-section">
            <div class="instance-section-heading">
              <i nz-icon nzType="shopping" nzTheme="outline"></i>
              <h3>{{ 'assistant.management.store.instance-detail.latest-package' | i18n }}</h3>
            </div>
            <p class="instance-validity">{{ vm.getStoreLatestPackageLabel(instance, vm.storeInstanceDetail()) }}</p>
          </section>

          <section class="instance-detail-section" *ngIf="vm.storeInstanceDetail() as detail">
            <div class="instance-section-heading">
              <i nz-icon nzType="setting" nzTheme="outline"></i>
              <div>
                <h3>{{ 'assistant.management.store.instance-detail.configuration' | i18n }}</h3>
                <p>{{ 'assistant.management.store.instance-detail.readonly-hint' | i18n }}</p>
              </div>
            </div>
            <dl class="instance-config-grid">
              <div
                ><dt>{{ 'assistant.management.store.detail.response-mode' | i18n }}</dt
                ><dd>{{ vm.getResponseLabel(detail.responseMode || 'Qa') | i18n }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.detail.message-types' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceMessageTypesLabel(detail) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.detail.sender-types' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceSenderTypesLabel(detail) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.create.filter.reply-visibility' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceReplyReceiverTypesLabel(detail) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.detail.trigger-keywords' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceTriggerKeywords(detail) }}</dd></div
              >
              <div *ngIf="vm.isStoreInstanceBatchMode(detail)"
                ><dt>{{ 'assistant.store.batch-trigger.message-count' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceTriggerCount(detail) }}</dd></div
              >
              <div *ngIf="vm.isStoreInstanceBatchMode(detail)"
                ><dt>{{ 'assistant.store.batch-trigger.interval-minutes' | i18n }}</dt
                ><dd>{{ vm.getStoreInstanceTriggerInterval(detail) }}</dd></div
              >
              <div
                ><dt>{{ 'assistant.management.store.instance-detail.duration' | i18n }}</dt
                ><dd>{{ vm.getStoreLatestPackageLabel(instance, detail) }}</dd></div
              >
            </dl>
          </section>
        </main>

        <footer class="instance-detail-footer">
          <button nz-button type="button" (click)="vm.closeStoreInstanceDetail()" testId="assistant-store-instance-detail-cancel-button">{{
            'common.cancel' | i18n
          }}</button>
          <button
            nz-button
            nzType="primary"
            type="button"
            *ngIf="vm.canEnableStoreSubscription(instance)"
            [nzLoading]="vm.storeActionLoadingId() === 'enable-' + instance.assistantId"
            (click)="vm.enableAssistantStoreSubscription(instance)"
            testId="assistant-store-instance-detail-enable-button"
          >
            <i nz-icon nzType="poweroff" nzTheme="outline"></i>
            {{ 'assistant.management.action.enable' | i18n }}
          </button>
          <button
            nz-button
            nzType="primary"
            type="button"
            [disabled]="!vm.storeInstanceName.trim() || vm.storeInstanceDetailLoading()"
            [nzLoading]="vm.storeInstanceDetailLoading()"
            (click)="vm.saveStoreInstanceDetail()"
            testId="assistant-store-instance-save-button"
          >
            <i nz-icon nzType="save" nzTheme="outline"></i>
            {{ 'common.save' | i18n }}
          </button>
        </footer>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>
